import {
  RegistrationTokenType,
  SignInWithBizsolMutation,
} from "@/generated/graphql";
import { graphql, HttpResponse } from "msw";

export const signInWithBizsolMutationHandler =
  graphql.mutation<SignInWithBizsolMutation>(
    "signInWithBizsol",
    ({ query, variables }) => {
      return HttpResponse.json(
        {
          data: {
            signInWithBizsol: {
              // token: {
              //   access_token: "", // サインインで取得したトークンを入れる
              //   id_token: "",
              //   refresh_token: "",
              //   token_type: "Bearer",
              // },
              registrationToken: {
                type: RegistrationTokenType.Company,
                code: "82eb2c543bb9bb1e824e237e0f3644bc98845c8e43f1f774324b89e0b91c381016112edefe388621ef15eeb0d67be757a01c833a69227884cd2083ef96c880dd11879c98ee1b5b4b5ffead453ef2ff415a613de17272eaa04b828f064060a673aca5cb3161229323b4afdefc789e3184fffd5bb8c714e4d3d54093633d0bd46d8f10812ed5660ce61cdd565f830247b61912105de5da07e94203d994e1a5c261c568c018934556a93b38d5bbe35653ee062fab85e13f9c77795a18bec8b3270a1eb7917ad567f88b2a0e3f15043719e4d8a319001caa891f96aad660fc414a9d691220bc4cf17a80b42f7583f8923577be4d9225559ac98796f5feac764b742bbfbf8f552aaf369585ce7433cf43efbd25b32d8c19d4c06dff95e554a24361860631253d9c362260b858e58cf576db873e0e63f1d1c36eb4a8336057440408d2bf39d1b32c3379500812f384ce37c02f3620dbf370cd0b439ee98147ed4fc2d83e59a4713772f8cb826c8b6b32b7d7da9c31edd7d07fe19b441e83e618de7ce722b472c79fd36640e241b3fb02a56f2abc0512843c024465ee9b0a1c3135ca08487ce7873b53fe96ee4fbcb884b96b934ec16473ba0e4cc17b21172a6b77d02394f4f9932eea996aaed06fe9a934e73c666dcfebb09503d9017fbb9f8227dc0fb4dabb153c1a8aaeaf247b8ede4cedf79351322f6d878fd69ef32cc23f70c85cb3d528d9c4042abc576cc80592a34eca5df385484c0bfd15d1f36c2a7c182d256ff680c1a3f25713d087dc0c3c3023f659edeacccd39cc4208c185628aa8783a95fcac9f32bc23cebd75816d0fdb984199d35721b03c11c0ddd1c71491ca8ae2be3a6962d365df4c91ae2fd752649992418bfe3af2fda6a346e95ae8de1a722d9b7baabf5c5f18b22f4173834186653cc79aecd68cf7f19940cf9d055d839eea08682de1666de4e0ddb40ac1751f31178b26ed350cc3d919806621737b516de44bcf402d1459acc8db181534d77675da35e769af8b3f423012a1b8ac53af396bfc3aed33f7928f97964343f9a6b164102b32a0c7eaa5083902117319aa5af17e78f2b1b025e3e467372a8f2b22bbaa8a3e94e7d791829e854e961f6788d3736f0c95af922701152cbe9b9fca0f2aeacc82714b7fd26dd75358c87ad048b619c6ecff98bd680be389ea212bc4c115b23601dc703362bc48d5faa99bdcdecf30d29aa6b869f7e0f62b751cad64317f8d3a7d04fc0065324287f2663508141f23404e0159ca45cfe49de7644a21b093ce5ba49540736811b6671366d2b5a12fe9aa2b575158e17df041bed7571789ab0a188f1d9f634b440aaa8d96a5492d2945",
              },
            },
          },
        }
        // ctx.errors([
        //   {
        //     extensions: {
        //       code: ErrorCode[ErrorCode.BIZSOL_USER_IS_ALREADY_CONNECTED],
        //     },
        //   },
        //   {
        //     extensions: {
        //       code:
        //         ErrorCode[ErrorCode.BIZSOL_REQUEST_FAILED] +
        //         ": service time is over. [210]",
        //     },
        //   },
        // ])
      );
    }
  );
